const companyFinancialsWithout = (variables, months = 35) => {
  const companyFinancials = []
  for (let i = 0; i <= months; i++) {
    companyFinancials.push(
      getMonthCompanyFinancials(
        variables,
        i,
        i > 0 ? companyFinancials[i - 1] : 0
      )
    )
  }
  return companyFinancials
  // console.log('companyFinancials', companyFinancials)
}

const getMonthCompanyFinancials = (variables, month, prevMonth) => {
  const vars = variables
  let valuation,
    sales,
    gross_profit,
    direct_costs,
    total_expenses,
    marketing_sales_costs,
    opex,
    funding,
    cash_balance,
    company_runway,
    number_of_shares,
    price_per_share,
    new_shares,
    new_ownership,
    founder_ownership

  if (month === 0) {
    sales = vars.mrr // C
    valuation = sales * 12 * vars.saas_multiple // A
    gross_profit = sales * vars.gross_margin // D
    direct_costs = sales - gross_profit // E
    total_expenses = vars.monthly_expenses // H
    marketing_sales_costs = sales * vars.sales_marketing_costs_share // G
    opex = total_expenses - marketing_sales_costs - direct_costs // F
    cash_balance = vars.bank_account_at_start // J
    company_runway =
      cash_balance < 0
        ? 'Out of cash'
        : cash_balance < total_expenses - gross_profit
        ? 'Last month'
        : '' // K
    funding =
      company_runway === 'Last month'
        ? (total_expenses - gross_profit) * vars.month_runway_runout
        : 0
    number_of_shares = vars.original_number_of_shares
    price_per_share = valuation / number_of_shares
    new_shares = funding / price_per_share
    new_ownership = funding / (valuation + funding)
    founder_ownership =
      vars.original_number_of_shares / (number_of_shares + new_shares)
  } else {
    sales = prevMonth.sales * (1 + vars.mom) // C
    valuation = sales * 12 * vars.saas_multiple // A
    gross_profit = sales * vars.gross_margin // D
    direct_costs = sales - gross_profit // E
    total_expenses = prevMonth.total_expenses * (1 + vars.total_expenses) // H
    marketing_sales_costs = sales * vars.sales_marketing_costs_share // G
    opex = total_expenses - marketing_sales_costs - direct_costs // F
    cash_balance =
      prevMonth.cash_balance - total_expenses + gross_profit + prevMonth.funding // J

    company_runway =
      cash_balance < 0
        ? 'Out of cash'
        : cash_balance < total_expenses - gross_profit
        ? 'Last month'
        : '' // Z
    funding =
      company_runway === 'Last month'
        ? (total_expenses - gross_profit) * vars.month_runway_runout
        : 0
    number_of_shares = prevMonth.number_of_shares + prevMonth.new_shares
    price_per_share = valuation / number_of_shares
    new_shares = funding / price_per_share
    new_ownership = funding / (valuation + funding)
    founder_ownership =
      vars.original_number_of_shares / (number_of_shares + new_shares)
  }
  return {
    valuation,
    month,
    sales,
    gross_profit,
    direct_costs,
    total_expenses,
    marketing_sales_costs,
    opex,
    funding,
    cash_balance,
    company_runway,
    number_of_shares,
    price_per_share,
    new_shares,
    new_ownership,
    founder_ownership
  }
}

export { companyFinancialsWithout }
